'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkUpperCase = exports.checkPostcode = exports.checkDate = undefined;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _lodash = require('lodash');
var check = function check(value) {
  switch (typeof value === 'undefined' ? 'undefined' : _typeof(value)) {
    case 'string':
      return value;
    case 'number':
      return value.toString();
    default:
      return undefined;
  }
};
var checkDate = function checkDate(value) {
  if (!(0, _lodash.isPlainObject)(value)) {
    return undefined;
  }
  var day = check(value.day);
  var month = check(value.month);
  var year = check(value.year);
  if (!day || !month || !year) {
    return undefined;
  }
  if (day.length === 1) {
    day = '0' + day;
  }
  if (month.length === 1) {
    month = '0' + month;
  }
  return [day, month, year];
};
var checkUpperCase = function checkUpperCase(value) {
  if (typeof value !== 'string') {
    return undefined;
  }
  return value.toUpperCase();
};
var checkPostcode = checkUpperCase;
exports.default = check;
exports.checkDate = checkDate;
exports.checkPostcode = checkPostcode;
exports.checkUpperCase = checkUpperCase;